import { render, staticRenderFns } from "./EntregasVisaoGeral.vue?vue&type=template&id=608c3af3"
import script from "./EntregasVisaoGeral.vue?vue&type=script&lang=js"
export * from "./EntregasVisaoGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports